export default __webpack_public_path__ + "static/media/culture-large-desktop.4b362d7a.png";